// extracted by mini-css-extract-plugin
export var carrierIcon = "_u2-0";
export var carrierLogo = "_u2-1";
export var detailsSection = "_u2-2";